import service from '../../utility/service';
import { errorOccurred } from '../../errors/reducer';

const INITIAL_STATE = {
  fetchingCcys: false,
  fetchingCcyPairs: false,
  currencies: undefined,
  currencyPairs: undefined,
  ccy1: undefined,
  ccy2: undefined

};


const types = {
  FETCHING_ADMIN_CURRENCIES: 'orb/admin/currencyPairs/FETCHING_ADMIN_CURRENCIES',
  FETCHING_ADMIN_CURRENCYPAIRS: 'orb/admin/currencyPairs/FETCHING_ADMIN_CURRENCYPAIRS',
  RECEIVED_ADMIN_CURRENCIES: 'orb/admin/groups/RECEIVED_ADMIN_CURRENCIES',
  RECEIVED_ADMIN_CURRENCYPAIRS: 'orb/admin/groups/RECEIVED_ADMIN_CURRENCYPAIRS',
  ADD_GROUP: 'orb/admin/groups/ADD_CCYPAIR',
  DELETE_GROUP: 'orb/admin/groups/DELETE_CCYPAIR',
  SELECT_CCY1: 'orb/admin/groups/SELECT_CCY1',
  SELECT_CCY2: 'orb/admin/groups/SELECT_CCY2',
  UPDATED_ADMIN_CURRENCYPAIR: 'orb/admin/groups/UPDATED_ADMIN_CURRENCYPAIR',
};


export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.FETCHING_ADMIN_CURRENCIES :
      return Object.assign({}, state, { fetchingCcys: true });

    case types.RECEIVED_ADMIN_CURRENCIES :
      return Object.assign({}, state, { fetchingCcys: false, currencies: action.currencies });

    case types.FETCHING_ADMIN_CURRENCYPAIRS :
      return Object.assign({}, state, { fetchingCcyPairs: true });

    case types.RECEIVED_ADMIN_CURRENCYPAIRS :
      return Object.assign({}, state, { fetchingCcyPairs: false, currencyPairs: action.currencyPairs });

    case types.SELECT_CCY1 :
      return Object.assign({}, state, { ccy1: action.ccy });
    case types.SELECT_CCY2 :
      return Object.assign({}, state, { ccy2: action.ccy });
    case types.UPDATED_ADMIN_CURRENCYPAIR:
      return Object.assign({}, state, { ccy1: '', ccy2: '' });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;


function fetchingCurrencies() {
  return { type: types.FETCHING_ADMIN_CURRENCIES };
}

function receivedCurrencies(ccys) {
  let data = ccys;
  if (ccys.Data) {
    data = data.Data;
  }
  return {
    type: types.RECEIVED_ADMIN_CURRENCIES,
    currencies: data
  };
}


function fetchingCurrencyPairs() {
  return { type: types.FETCHING_ADMIN_CURRENCYPAIRS };
}

function receivedCurrencyPairs(ccyPairs) {
  return {
    type: types.RECEIVED_ADMIN_CURRENCYPAIRS,
    currencyPairs: ccyPairs
  };
}

function updatedCurrencyPair() {
  return {
    type: types.UPDATED_ADMIN_CURRENCYPAIR
  };
}
function fetchCurrencies() {
  return (dispatch) => {
    dispatch(fetchingCurrencies());
    return service.get('Currencies').then((response) => {
      dispatch(receivedCurrencies(response.data));
    }).catch((err) => {
      dispatch(errorOccurred(err, 'Getting currency list for admin'));
      dispatch(receivedCurrencies([]));
    });
  };
}

export function fetchCurrencyPairs() {
  return (dispatch) => {
    dispatch(fetchingCurrencyPairs());
    return service.get('CurrencyPairs').then((response) => {
      dispatch(receivedCurrencyPairs(response.data));
    }).catch((err) => {
      dispatch(errorOccurred(err, 'Getting currency list for admin'));
      dispatch(receivedCurrencyPairs([]));
    });
  };
}

export function fetchCurrencyPairDataIfNeeded() {
  return (dispatch, getState) => {
    const admin = getState().admin;
    const { ccyInfo } = admin;
    const promises = [];

    if (ccyInfo.currencies === undefined) {
      const ccyPromise = dispatch(fetchCurrencies());
      promises.push(ccyPromise);
    }

    if (ccyInfo.currencyPairs === undefined) {
      const ccyPairPromise = dispatch(fetchCurrencyPairs());
      promises.push(ccyPairPromise);
    }

    return Promise.all(promises);
  };
}

export function selectCcy1(ccy) {
  return { type: types.SELECT_CCY1, ccy };
}

export function selectCcy2(ccy) {
  return { type: types.SELECT_CCY2, ccy };
}
export function addCurrencyPair(ccy1, ccy2) {
  return dispatch => service.post(`/Admin/CurrencyPairs/${ccy1}/${ccy2}`).then(() => {
    dispatch(updatedCurrencyPair());
    dispatch(fetchCurrencyPairs());
  }).catch((err) => {
    dispatch(errorOccurred(err, 'Error adding currency pair'));
  });
}

export function removeCurrencyPair(ccy1, ccy2) {
  return dispatch => service.delete(`/Admin/CurrencyPairs/${ccy1}/${ccy2}`).then(() => {
    dispatch(updatedCurrencyPair());
    dispatch(fetchCurrencyPairs());
  }).catch((err) => {
    dispatch(errorOccurred(err, 'Error removing currency pair'));
  });
}



// WEBPACK FOOTER //
// ./src/admin/currencyPairs/reducer.js